<template>
  <div class="news-list-skeleton" aria-hidden="true">
    <div
      v-for="i in 5"
      :key="i"
      class="skeleton-card"
      :style="{ animationDelay: `${(i - 1) * 0.12}s` }"
    >
      <div class="skeleton-shimmer" />
      <div class="skeleton-overlay">
        <div class="skeleton-date skel-line" style="width: 90px; margin-bottom: 8px" />
        <div class="skel-line" style="width: 92%" />
        <div class="skel-line" style="width: 64%; margin-top: 8px" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.news-list-skeleton {
  padding-bottom: 30px;
}

/* Match exact dimensions of news-item-style-2.vue */
.skeleton-card {
  position: relative;
  height: 210px;
  border-radius: 13px;
  overflow: hidden;
  margin: 20px 0 40px 0;
  background: #1c1c30;
  animation: card-fade-in 0.3s ease both;
}

.skeleton-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0.03) 8%,
    rgba(255, 255, 255, 0.09) 18%,
    rgba(255, 255, 255, 0.03) 33%
  );
  background-size: 800px 100%;
  animation: shimmer 1.8s infinite linear;
}

.skeleton-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 18px 20px 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background: linear-gradient(
    180deg,
    transparent 0%,
    rgba(0, 0, 0, 0.55) 40%,
    rgba(0, 0, 0, 0.72) 100%
  );
}

.skel-line {
  height: 20px;
  border-radius: 4px;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0.13) 8%,
    rgba(255, 255, 255, 0.24) 18%,
    rgba(255, 255, 255, 0.13) 33%
  );
  background-size: 800px 100%;
  animation: shimmer 1.8s infinite linear;
}

.skeleton-date {
  height: 13px;
}

@keyframes shimmer {
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}

@keyframes card-fade-in {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 768px) {
  .skeleton-card {
    height: 170px;
    border-radius: 12px;
    margin: 15px 0 30px 0;
  }
  .skel-line { height: 16px; }
}

@media (max-width: 480px) {
  .skeleton-card {
    height: 140px;
    border-radius: 10px;
  }
  .skel-line { height: 13px; }
}
</style>
